/* KUPP · Eventos extra del píxel de Meta (los de compra los manda la app de Facebook de Shopify).
   Usa el fbq que ya carga la app; si no existe (sin consentimiento, bloqueador), no hace nada.
   - Contact: clic en cualquier link de WhatsApp (wa.me / api.whatsapp.com), con el lugar del clic.
   - KuppInteres: lleva 20 s en la página y bajó al menos a la mitad (una vez por página). Sirve para públicos de gente interesada.
   - Eventos de las landings (kupp-pz / kupp-prov): las secciones avisan con document.dispatchEvent(new CustomEvent('kupp:meta', { detail: { ev, params, custom, once } })).
   Nunca se manda dato personal en los parámetros; la coincidencia avanzada (teléfono/nombre) solo la pone el formulario de mayoreo con fbq('init'). */
(function () {
  'use strict';
  if (window.__kuppMeta) return;
  window.__kuppMeta = true;
  var sent = {};

  function canTrack() {
    if (typeof window.fbq !== 'function') return false;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.userCanBeTracked === 'function' && cp.userCanBeTracked() === false) return false;
    return true;
  }
  function pageType() {
    var p = location.pathname;
    if (/\/pages\/gracias-mayoreo/.test(p)) return 'gracias-mayoreo';
    if (/\/pages\/(revendedores|mayoreo)/.test(p)) return 'mayoreo';
    if (/\/products\/vasos-glitter-personalizados/.test(p)) return 'personalizados';
    if (/\/products\//.test(p)) return 'producto';
    if (/\/collections\//.test(p)) return 'coleccion';
    if (/\/cart/.test(p)) return 'carrito';
    if (p === '/' || p === '') return 'inicio';
    return 'otra';
  }
  function track(ev, params, custom, once) {
    if (!canTrack()) return;
    var key = once ? ev + '|' + once : '';
    if (key && sent[key]) return;
    if (key) sent[key] = 1;
    var data = { page_type: pageType() };
    for (var k in params || {}) if (params[k] !== '' && params[k] != null) data[k] = params[k];
    try { window.fbq(custom ? 'trackCustom' : 'track', ev, data); } catch (e) {}
  }
  window.kuppMeta = track;

  // Respaldo del formulario de mayoreo: si después del captcha Shopify regresa a otra página con ?contact_posted=true,
  // se manda a la página del formulario para mostrar la gracias y disparar el Lead (lo hace kupp-prov.js).
  try {
    var saved = JSON.parse(sessionStorage.getItem('kpvLead') || 'null');
    if (saved && saved.path && /[?&]contact_posted=true/.test(location.search) && location.pathname !== saved.path &&
        Date.now() - (saved.t || 0) < 30 * 60 * 1000 && !document.querySelector('[data-kpv-hero]')) {
      location.replace(saved.path + '?contact_posted=true'); // kupp-prov.js lo manda a la página de gracias
    }
  } catch (e) {}

  // Eventos que avisan las secciones
  document.addEventListener('kupp:meta', function (e) {
    var d = e.detail || {};
    if (d.ev) track(d.ev, d.params, d.custom, d.once);
  });

  // Clic en un elemento con data-meta-ev="NombreDelEvento" → evento personalizado (una vez por página)
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-meta-ev]');
    if (el) track(el.getAttribute('data-meta-ev'), { content_name: (el.textContent || '').trim().slice(0, 60) }, true, 'click');
  }, true);

  // Contact: clic en WhatsApp (no cuenta dos veces el mismo lugar en 30 s)
  var lastWa = {};
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
    if (!a) return;
    var sec = a.closest('[id^="shopify-section-"]');
    var where = (a.getAttribute('data-meta-where') || (sec ? sec.id.replace('shopify-section-', '').replace(/^template--\d+__/, '') : 'otro')).slice(0, 60);
    var now = Date.now();
    if (lastWa[where] && now - lastWa[where] < 30000) return;
    lastWa[where] = now;
    track('Contact', { content_name: 'WhatsApp', content_category: where });
  }, true);

  // KuppInteres: 20 s en la página + 50 % de scroll
  var t0 = Date.now(), deep = false, done = false;
  function check() {
    if (done) return;
    var h = document.documentElement;
    var pct = (window.scrollY + window.innerHeight) / Math.max(h.scrollHeight, 1);
    if (pct >= 0.5) deep = true;
    if (deep && Date.now() - t0 >= 20000) {
      done = true;
      window.removeEventListener('scroll', onScroll);
      track('KuppInteres', { content_name: document.title.slice(0, 80) }, true);
    }
  }
  var raf = 0;
  function onScroll() { if (!raf) raf = setTimeout(function () { raf = 0; check(); }, 250); }
  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(check, 20500);
})();
